import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_MTL_MOW_REG_005_POP_003 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
      grid1: React.createRef<SnGridRef>(),
    });

    const getGridCurrent = (key: string): SnGridRef => {
      const grid = gridRefs.current[key]?.current;
      if (!grid) {
        throw new Error(`Grid '${key}' is not mounted yet`);
      }
      return grid;
    };

    const searchRef = useRef<any>(null);
    const autoConfirmRef = useRef(false); // no_wo 자동조회 여부

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });

    useImperativeHandle(ref, () => ({
      getOkayData: () => {
        let headerRows: any[] = [];

        // no_wo로 자동조회된 결과가 1건이면 선택 없이 그대로 반환
        if (selectedData?.no_wo && dataSources.grid1.length === 1) {
          headerRows = dataSources.grid1;
        } else {
          const focusedRowNode = getGridCurrent("grid1").focusedRowNode();
          if (focusedRowNode) {
            headerRows = [focusedRowNode.data];
          }
        }

        // 선택된 작업지시의 라인을 no_wo로 수집
        const noWos = headerRows.map((row: any) => row.no_wo);
        const lineRows = dataSources.grid2.filter((row: any) =>
          noWos.includes(row.no_wo)
        );

        return {
          rtnData: [headerRows, lineRows],
        };
      },
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_MTL_MOW_REG_005_POP_003",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
          });

          if (mergedData.no_wo) {
            autoConfirmRef.current = true;
            onSearch(mergedData);
          }
        } catch (error) {}
      };
      fetchform();
    }, []);

    // 자동조회 결과가 1건이면 팝업을 바로 닫으면서 해당 행을 반환
    useEffect(() => {
      if (!autoConfirmRef.current) return;
      autoConfirmRef.current = false;

      if (dataSources.grid1.length === 1) {
        modalRef?.current?.handleConfirm(true);
      }
    }, [dataSources]);

    const onSearch = async (searchParams?: any) => {
      try {
        const param = {
          id: "sn_mtl_mow_reg_005_pop_003_01",
          params: searchParams ?? searchRef.current.getFormdata(),
        };
        getGridCurrent("grid1").resetUpdate();

        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0] || [],
          grid2: data[1] || [],
        });
      } catch (error: any) {}
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
        },
      }),
      [columns, dataSources]
    );

    return (
      <div>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{
              width: 80,
              marginTop: 1.5,
            }}
            spinner={true}
          />
        </div>
        <div>
          <div
            style={{
              height: "55vh",
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <SnGrid
              ref={gridRefs.current["grid1"]}
              columnConfig={grids.grid1.columns}
              rowData={grids.grid1.dataSource}
              etcProps={{
                rowSelection: "single",
                isEditable: false,
              }}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_MTL_MOW_REG_005_POP_003;
